// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1clDX","footer":"ModalInfo_footer__2ZnyK"};